import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close align-text-top",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString($props.title), 1),
    _hoisted_3
  ]))
}